/*
  Author: Vaishnavi
  Date: 26/11/2019
  Issue Description: Spacing fixes done, Removed header
*/

/*
Author: Vinod
Date: 04/12//2019
Issue_id JIRA: PL-1980
Issue Description: When added the data and clicked on Skip, should throw an error message that data is not saved.
search_string: UAT_60
*/

<template>
  <div>
    <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
      You have only view permission.
    </div>
    <span class="input-label">Enter number of Years and Days</span>
    <section class="inlineFields" :disabled="!(ifTeamleaderPermission)">
      <txt
        autofocus="autofocus"
        type="text"
        v-model="gratuityModel.years"
        name="years"
        placeholder="years"
        class="customwidth"
        v-validate="{required:true, numeric:true}"
        :classname="errors.has('years')"
        :errormsg="errors.first('years')"
      />
      <span class="marginleft8 marginright-56">Years *</span>
      <txt
        class="sideField customwidth"
        type="text"
        v-model="gratuityModel.days"
        name="days"
        placeholder="days"
        v-validate="{required:true, numeric:true}"
        :classname="errors.has('days')"
        :errormsg="errors.first('days')"
      />
      <span class="marginleft8">Days *</span>
    </section>

    <div class="formulaDiv margintop-32">
      <span class="heading">Formula -</span>
      <div class="totalFormula">
        <span class="top-formula">(Basic Salary + DA)</span>
      </div>
      <div class="lineFormula">
        <div class="line"></div>
        <span class="mid-formula">x 15 x no. of years of service</span>
      </div>
      <span class="bottom-formula">26</span>
    </div>
    <tick-animation v-if="showSuccessMsg"></tick-animation>

    <!-- Start UAT_60 -->
    <pop-up-message
      v-if="showWarningPopup"
      message="On skip, your made changes won't be saved!"
      popupType="Warning"
      :popupHeaderMessage="'Warning'"
      :closable="false"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancelEvent()">Cancel</button>
          <button class="btn-popup" type="button" @click="skip()">Skip</button>
        </div>
      </template>
    </pop-up-message>
    <!-- End UAT_60 -->

    <bottom-action-container>
      <btn-skip @navClicked="skip()"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="$emit('previous')" />
          <btn text="Next" type="primary" @click="SaveGratuity"  v-show="(ifTeamleaderPermission || ifSuperAdmin || ifAnchor)"/>
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "Gratuity",
  data() {
    return {
      showSuccessMsg: false,
      showWarningPopup: false, // UAT_60
      responseMsg: "",
      errmsg: "",
      toast: false,
      gratuityModel: {
        years: "4",
        days: "240"
      },//Default data
      statutorySettingsValue: false,
      role: ""
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      getGratuityData: "onboard/statutoryinfo/gratuity/getGratuityData"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      } else {
        return this.getleid(0);
      }
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgId: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.statutorySettingsValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.statutorySettingsValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
        // }
        // else {
        //  return true
      //}
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  mounted() {
    this.setGratuityData(this.getGratuityData[this.le_id]);
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions("onboard/statutoryinfo/gratuity/", {
      act_fetchAll: "fetchAll",
      act_create: "create"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),
    // Start UAT_60
    cancelEvent() {
      this.showWarningPopup = false;
    },

    skip() {
      this.showWarningPopup = false;
      this.$emit("skip");
    },
    // End UAT_60

    /* function to set form data */
    setGratuityData(Obj) {
      try {
        if (Object.keys(Obj).length) {
          this.gratuityModel = Obj;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Function to submit the form data to server */
    async create() {
      try {
        this.$root._data.isSaving = true;
        let res = await this.act_create({
          data: {
            ...this.gratuityModel,
            le_id: this.le_id
          }
        });
        setTimeout(() => {
          if (res.data.status) {
            this.responseMsg = "Gratuity Settings " + res.data.message;
            this.showSuccessMsg = true;
            this.hideSuccessMsg();
          }
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to hide success message and to navigate to next screen */
    hideSuccessMsg() {
      setTimeout(() => {
        this.showSuccessMsg = false;
        this.$emit("next");
      }, 1000);
    },
    /* function to validate form */
    SaveGratuity() {
      if(this.ifAnchor) {
          this.nextPage();
        } else {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.create();
          this.$validator.reset();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
      }
    },

    /* function is use to move next page as user role is anchor */
    nextPage() {
      this.$emit("skip");
    },

    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.statutorySettingsValue = data.data.user.permissions.statutory_settings ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
.label {
  color: #34c0be;
}
.inlineFields {
  display: flex;
}
.formulaDiv {
  padding: 15px;
  background-color: #f1f1f1;
}
.heading {
  color: #444444;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 2%;
}
.totalFormula {
  margin-top: 2%;
  color: #404040;
  font-size: 14px;
}
.line {
  color: #6e6e6e;
  width: 15%;
  border-bottom: 1px solid #979797;
}
.lineFormula {
  display: flex;
  height: 10px;
  color: #6e6e6e;
  margin-bottom: 1%;
  font-size: 12px;
}
.top-formula {
  margin-top: 2%;
  margin-left: 2%;
  font-size: 14px;
  color: #404040;
}
.mid-formula {
  font-size: 14px;
  color: #404040;
  margin-left: 5px;
}
.bottom-formula {
  margin-left: 7%;
  font-size: 14px;
  color: #404040;
}
.customwidth {
  width: 200px;
  height: 35px;
  background-color: #ffffff;
}
.marginleft8 {
  margin-left: -16px;
  margin-top: 8px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
